import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { Sphere, MeshDistortMaterial, Float, Environment } from '@react-three/drei';
import { useRef } from 'react';

function BrainMesh() {
  const mesh = useRef();
  const { viewport } = useThree();

  // Responsive Scale Logic
  const scale = viewport.width < 5 ? 1.5 : 2.4;

  useFrame((state) => {
    mesh.current.rotation.y = state.clock.getElapsedTime() * 0.1;
    mesh.current.rotation.x = Math.sin(state.clock.getElapsedTime() * 0.5) * 0.05;
  });

  return (
    <Float speed={2} rotationIntensity={0.5} floatIntensity={1}>
      <Sphere args={[1, 120, 120]} scale={scale} ref={mesh}>
        <MeshDistortMaterial
          color="#5EE1D9"
          attach="material"
          distort={0.5}
          speed={1.5}
          roughness={0.1}
          metalness={0.1}
          transmission={0.5}
          thickness={0.5}
        />
      </Sphere>
    </Float>
  );
}

export default function HeroBrain() {
  return (
    <div className="h-full w-full">
      <Canvas camera={{ position: [0, 0, 5], fov: 50 }} gl={{ alpha: true }}>
        <ambientLight intensity={0.8} />
        <directionalLight position={[10, 10, 5]} intensity={2} color="#CABDFF" />
        <pointLight position={[-10, -10, -5]} intensity={1} color="#5EE1D9" />
        <BrainMesh />
        <Environment preset="city" />
      </Canvas>
    </div>
  );
}
